import { CopyAll } from '@mui/icons-material';
import CustomModal from '../../modals';
import ImageClass from '../../../assets';
import { TransformedCalendarEventObject } from '../../../params/redux/calendar';
import { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { formatDate, formatTime } from '../../../helper';

interface CalendarEventDetailProps {
    open: boolean;
    onClose: () => void;
    selectedEvent: TransformedCalendarEventObject;
}

const CalendarEventDetail = ({ open, onClose, selectedEvent }: CalendarEventDetailProps) => {
    const [showAttendee, setShowAttendee] = useState<HTMLElement | null>(null);

    const handleAttendeeClick = (eventFromButton: React.MouseEvent<HTMLButtonElement>) => {
        setShowAttendee(eventFromButton.currentTarget);
    };

    const handleCopyLink = () => {
        if (selectedEvent.googleMeetLink) {
            navigator.clipboard.writeText(selectedEvent.googleMeetLink);
        }
    };

    return <CustomModal open={open} handleClose={onClose} title={selectedEvent.title}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5">{selectedEvent.title}</Typography>
            {selectedEvent.attendees.length !== 0 && <Button variant="text" onClick={handleAttendeeClick}>View Attendees</Button>}
            <Menu
                anchorEl={showAttendee}
                open={Boolean(showAttendee)}
                onClose={() => setShowAttendee(null)}
                MenuListProps={{
                    'aria-labelledby': 'event-calendar-button'
                }}
            >
                {
                    selectedEvent.attendees?.map((item, index) => (
                        <MenuItem key={index}>
                            <Typography variant="body2" color="textSecondary">{item.email}</Typography>
                        </MenuItem>
                    ))
                }
            </Menu>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
            <Typography variant="body2">{formatDate((selectedEvent.start instanceof Date ? selectedEvent.start.toISOString() : selectedEvent.start) || '2025-01-24T05:00:00+05:00', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            })}</Typography>
            <Typography variant="body2">{formatTime((selectedEvent.start instanceof Date ? selectedEvent.start.toISOString() : selectedEvent.start) || '2025-01-24T05:00:00+05:00', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })} - {formatTime((selectedEvent.end instanceof Date ? selectedEvent.end.toISOString() : selectedEvent.end) || '2025-01-24T05:00:00+05:00', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })}</Typography>
        </Box>
        <Typography variant="body1" color="textSecondary">{selectedEvent.desc || 'Description is Empty'}</Typography>
        {selectedEvent.googleMeetLink !== null && <Box display="flex" gap="10px" mt={2}>
            <Button
                variant="outlined"
                fullWidth
                href={selectedEvent.googleMeetLink || '#'}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={ImageClass.googleMeetLogo} height="30px" alt="Google Meet" /> Google Meet
            </Button>
            <Button variant="outlined" fullWidth onClick={handleCopyLink}><CopyAll /> Copy Meeting Link</Button>
        </Box>}
    </CustomModal>;
};

export default CalendarEventDetail;